import Errors from "./Errors";

class Form {

    constructor(data) {
        this.originalData = data;

        for (const field in data) {

            this[field] = data[field];



        }

        this.errors = new Errors();
    }

    reset() {

        for (let field in this.originalData) {
            this[field] = '';
        }

        this.errors.clear();

    }


    formData() {

        let ret = {};

        for (let elem in this.originalData) {

            ret[elem] = this[elem];

        }

        return ret

    }

    onSuccess(data) {

        this.reset();

    }

    onFail(err) {


        // debugger;

        this.errors.record(err.response.data.errors);
        console.log(err.response);


    }

    post(url){

        return this.submit('post',url)

    }


    submit(method, url) {

        return new Promise((resolve, reject) => {



            axios[method](url,

                this.formData()

            ).then(response => {
                this.onSuccess(response.data) // .bind(this)


                resolve(response.data)

            })
                .catch(err => {
                    this.onFail(err)//.bind(this)
                    reject(err)
                });


        });


    }
}

export default Form;
